import React from 'react';

/**
 * PageHeader — en-tête de page unifié, calé sur le langage éditorial du Dashboard
 * (titre serif Newsreader, eyebrow optionnel, sous-titre discret, actions à droite).
 * Remplace les `text-xl`/`fontSize:25` ad hoc éparpillés dans les pages internes.
 *
 * Props : title, subtitle?, eyebrow?, actions? (noeud React), size? (px, défaut 26).
 */
export default function PageHeader({ title, subtitle, eyebrow, actions, size = 26 }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
      <div>
        {eyebrow && (
          <div className="text-[10.5px] uppercase tracking-[0.2em] mb-2" style={{ color: 'var(--text-tertiary)' }}>
            {eyebrow}
          </div>
        )}
        <h1 className="font-serif" style={{ fontSize: size, fontWeight: 400, letterSpacing: '-0.012em', lineHeight: 1.08, color: 'var(--text-primary)' }}>
          {title}
        </h1>
        {subtitle && (
          <p className="mt-2 text-[12.5px]" style={{ color: 'var(--text-tertiary)' }}>{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-3 self-start sm:self-auto">{actions}</div>}
    </div>
  );
}
